/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */

import genericStyles from "../../Styles/genericStyles.module.css";
import MUIDataTableCustomStyle from "../../Components/MUIDataTableCustomStyle";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useState, createContext } from "react";
import { endpoints } from "../../Utils/UrlEnum";
import { Button, Chip } from "@mui/material";
import { ETableEditAction, EWidths } from "../../Utils/Enums";
import GenericModal from "../GenericModal";
import { FormsIds, TablesIds } from "../../Utils/Constants";
import { SubscriptionModel } from "../../Utils/Models";
import SubscriptionForm from "./SubscriptionForm";
// import SubscriptionForm from "./SubscriptionForm";

export const CRUDContext = createContext(new SubscriptionModel());

export default function SubscriptionsTable() {
  const [contextValue, setContextValue] = useState(new SubscriptionModel());
  const [open, setOpen] = useState(false);
  const [triggerReload, setTriggerReload] = useState<undefined | boolean>();

  /**
   * Columns definition for subscriptions table
   */
  const subscriptionColumns = [
    {
      label: `${Vocabulary.name}`,
      name: "name",
      options: {
        sort: false,
      },
    },
    {
      label: `${Vocabulary.price}`,
      name: "price",
      options: {
        sort: false,
        customBodyRender: (value: number) => {
          return value ? `${value} RON` : "-";
        },
      },
    },
    {
      label: `${Vocabulary.duration}`,
      name: "durationInDays",
      options: {
        sort: false,
        customBodyRender: (value: number) => {
          return value ? `${value} zile` : "-";
        },
      },
    },
    {
      label: `${Vocabulary.benefits}`,
      name: "benefits",
      options: {
        sort: false,
        customBodyRender: (value: Array<{ name: string }>) => {
          if (!value || value.length === 0) return "-";
          return (
            <div>
              {value.slice(0, 2).map((benefit, index) => (
                <Chip
                  key={index}
                  label={benefit.name}
                  size="small"
                  variant="outlined"
                  style={{ margin: "2px" }}
                />
              ))}
              {value.length > 2 && (
                <Chip
                  label={`+${value.length - 2}`}
                  size="small"
                  variant="outlined"
                  style={{ margin: "2px" }}
                />
              )}
            </div>
          );
        },
      },
    },
    {
      label: `${Vocabulary.status}`,
      name: "isActive",
      options: {
        setCellHeaderProps: () => ({
          align: "center",
        }),
        setCellProps: () => ({
          align: "center",
        }),
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (rowData: boolean) => {
          return (
            <Chip
              color={rowData ? "success" : "default"}
              key={rowData.toString()}
              label={rowData ? Vocabulary.active : Vocabulary.inactive}
              style={{
                margin: 5,
              }}
            />
          );
        },
      },
    },
  ];

  return (
    <div className={genericStyles.mainContainer}>
      <CRUDContext.Provider value={contextValue}>
        <MUIDataTableCustomStyle
          onEditAction={ETableEditAction.MODAL}
          title={Vocabulary.subscriptions}
          columns={subscriptionColumns}
          CRUDEndPoint={endpoints.subscriptions.main}
          id={TablesIds.subscriptions}
          handleModalForm={setOpen}
          addOrEditForm={
            <GenericModal
              onClose={() => {
                setOpen(false);
                setContextValue(new SubscriptionModel());
              }}
              maxWidth={EWidths.MD}
              open={open}
              actions={
                <div className={genericStyles.modalActions}>
                  <Button
                    color="secondary"
                    onClick={() => {
                      setOpen(false);
                      setContextValue(new SubscriptionModel());
                    }}
                    variant="outlined"
                    fullWidth
                  >
                    {Vocabulary.cancel}
                  </Button>
                  <Button
                    fullWidth
                    type="submit"
                    form={FormsIds.subscriptionForm}
                    variant="contained"
                  >
                    {Vocabulary.save}
                  </Button>
                </div>
              }
              title={Vocabulary.editModalTitle}
            >
              <SubscriptionForm
                onClose={() => {
                  setTriggerReload(!triggerReload);
                  setOpen(false);
                  setContextValue(new SubscriptionModel());
                }}
                selectedRow={contextValue}
                open={open}
              />
            </GenericModal>
          }
          setContextValue={setContextValue}
          triggerReload={triggerReload}
        />
      </CRUDContext.Provider>
    </div>
  );
}
